var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 48,
    viewBox: "0 0 162 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 161,
    height: 47,
    rx: 8.5,
    fill: "#FFFFFF",
    stroke: "#C6C7D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3421 15.8783C84.2603 15.8783 83.3483 15.4982 82.6271 14.7501C81.9118 14.0229 81.5125 13.0204 81.5304 11.997C81.5304 10.9047 81.8999 9.98004 82.6271 9.24687C83.3453 8.49874 84.2573 8.11869 85.3391 8.11869C86.409 8.11869 87.321 8.49874 88.0541 9.24687C88.7813 10.004 89.1508 10.9287 89.1508 11.997C89.1389 13.0923 88.7693 14.0169 88.0541 14.7471C87.3359 15.5012 86.4239 15.8783 85.3421 15.8783ZM53.1526 15.8783C52.0946 15.8783 51.1767 15.5042 50.4257 14.7651C49.6806 14.0289 49.3021 13.0982 49.3021 12C49.3021 10.9017 49.6806 9.97106 50.4257 9.2349C51.1618 8.49575 52.0797 8.12168 53.1526 8.12168C53.6771 8.12168 54.1867 8.22642 54.6755 8.43889C55.1553 8.64537 55.5457 8.92667 55.8348 9.27081L55.9063 9.35759L55.0987 10.1536L55.0152 10.0549C54.5592 9.51021 53.9483 9.24388 53.1406 9.24388C52.4194 9.24388 51.7906 9.50123 51.272 10.01C50.7505 10.5217 50.4853 11.192 50.4853 12.003C50.4853 12.814 50.7505 13.4843 51.272 13.996C51.7906 14.5047 52.4194 14.7621 53.1406 14.7621C53.9095 14.7621 54.5563 14.5047 55.0599 13.996C55.3579 13.6967 55.5427 13.2778 55.6083 12.7481H53.0185V11.6289H56.7199L56.7348 11.7307C56.7616 11.9192 56.7885 12.1137 56.7885 12.2933C56.7885 13.3257 56.4785 14.1606 55.8646 14.777C55.1672 15.5072 54.2553 15.8783 53.1526 15.8783ZM95.9517 15.7197H94.8103L91.3145 10.1027L91.3443 11.1142V15.7167H90.2028V8.28029H91.5052L91.541 8.33714L94.8282 13.6279L94.7984 12.6194V8.28029H95.9517V15.7197V15.7197ZM76.765 15.7197H75.6086V9.39949H73.6029V8.28029H78.7677V9.39949H76.762V15.7197H76.765ZM72.6612 15.7197H71.5078V8.28029H72.6612V15.7197ZM66.1792 15.7197H65.0258V9.39949H63.0201V8.28029H68.1849V9.39949H66.1792V15.7197ZM62.29 15.7077H57.8673V8.28029H62.29V9.39949H59.0236V11.4404H61.9711V12.5476H59.0236V14.5885H62.29V15.7077ZM83.4735 13.981C83.989 14.4987 84.6149 14.7591 85.3421 14.7591C86.0901 14.7591 86.7011 14.5047 87.2107 13.981C87.7173 13.4723 87.9736 12.805 87.9736 12C87.9736 11.195 87.7173 10.5247 87.2137 10.0189C86.6981 9.50123 86.0692 9.24089 85.3451 9.24089C84.597 9.24089 83.9861 9.49525 83.4794 10.0189C82.9728 10.5277 82.7165 11.195 82.7165 12C82.7165 12.805 82.9698 13.4753 83.4735 13.981Z",
    fill: "#2B2733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4231 26.1067C78.6068 26.1067 76.3239 28.2524 76.3239 31.212C76.3239 34.1446 78.6217 36.3172 81.4231 36.3172C84.2395 36.3172 86.5223 34.1566 86.5223 31.212C86.5223 28.2524 84.2395 26.1067 81.4231 26.1067ZM81.4231 34.2943C79.8824 34.2943 78.5561 33.0135 78.5561 31.2C78.5561 29.3596 79.8853 28.1057 81.4231 28.1057C82.9639 28.1057 84.2901 29.3596 84.2901 31.2C84.2931 33.0254 82.9639 34.2943 81.4231 34.2943ZM70.2979 26.1067C67.4816 26.1067 65.1987 28.2524 65.1987 31.212C65.1987 34.1446 67.4965 36.3172 70.2979 36.3172C73.1142 36.3172 75.3971 34.1566 75.3971 31.212C75.3971 28.2524 73.1112 26.1067 70.2979 26.1067ZM70.2979 34.2943C68.7571 34.2943 67.4309 33.0135 67.4309 31.2C67.4309 29.3596 68.7601 28.1057 70.2979 28.1057C71.8387 28.1057 73.1649 29.3596 73.1649 31.2C73.1649 33.0254 71.8387 34.2943 70.2979 34.2943ZM57.0597 27.6658V29.8264H62.2244C62.0665 31.0384 61.6671 31.9332 61.0562 32.5466C60.2992 33.3067 59.1309 34.1327 57.0716 34.1327C53.8976 34.1327 51.4151 31.5591 51.4151 28.3721C51.4151 25.185 53.8976 22.6115 57.0716 22.6115C58.7852 22.6115 60.0339 23.2908 60.9608 24.1586L62.4867 22.6264C61.1992 21.3875 59.4856 20.4389 57.0835 20.4389C52.7294 20.4389 49.0756 24 49.0756 28.3601C49.0756 32.7322 52.7264 36.2813 57.0835 36.2813C59.4349 36.2813 61.1992 35.5092 62.594 34.0549C64.0155 32.6274 64.4656 30.6135 64.4656 28.9885C64.4656 28.4828 64.4268 28.0279 64.3464 27.6419H57.0567C57.0597 27.6389 57.0597 27.6658 57.0597 27.6658ZM111.208 29.3476C110.782 28.2015 109.494 26.0948 106.854 26.0948C104.237 26.0948 102.061 28.1626 102.061 31.2C102.061 34.0668 104.213 36.3052 107.107 36.3052C109.431 36.3052 110.785 34.8778 111.342 34.0399L109.616 32.8788C109.044 33.7317 108.248 34.2913 107.119 34.2913C105.977 34.2913 105.179 33.7706 104.648 32.7441L111.446 29.9162C111.446 29.9192 111.208 29.3476 111.208 29.3476ZM104.276 31.0534C104.222 29.0813 105.802 28.0788 106.931 28.0788C107.822 28.0788 108.564 28.5187 108.818 29.1591L104.276 31.0534ZM98.7533 36H100.985V21.0015H98.7533V36ZM95.0876 27.2409H95.0071C94.5034 26.6394 93.5468 26.0948 92.3249 26.0948C89.7887 26.0948 87.4522 28.3362 87.4522 31.215C87.4522 34.0818 89.7768 36.2963 92.3249 36.2963C93.5319 36.2963 94.5034 35.7486 95.0071 35.1352H95.0876V35.8683C95.0876 37.8165 94.0504 38.8668 92.3785 38.8668C91.0106 38.8668 90.1612 37.8793 89.8155 37.0534L87.8754 37.8673C88.4327 39.214 89.9198 40.8808 92.3755 40.8808C94.9922 40.8808 97.2095 39.3337 97.2095 35.5601V26.4H95.0995V27.2409C95.1025 27.2409 95.0876 27.2409 95.0876 27.2409ZM92.5246 34.2943C90.9838 34.2943 89.6963 33.0015 89.6963 31.215C89.6963 29.4135 90.9838 28.1087 92.5246 28.1087C94.0504 28.1087 95.2336 29.4284 95.2336 31.215C95.2485 33.0015 94.0534 34.2943 92.5246 34.2943ZM121.659 21.0015H116.322V36H118.554V30.3202H121.662C124.133 30.3202 126.562 28.5217 126.562 25.6668C126.562 22.812 124.142 21.0015 121.659 21.0015ZM121.725 28.2254H118.551V23.0783H121.725C123.397 23.0783 124.342 24.4638 124.342 25.6519C124.342 26.8279 123.385 28.2254 121.725 28.2254ZM135.509 26.0798C133.887 26.0798 132.215 26.801 131.524 28.3721L133.503 29.198C133.929 28.3721 134.71 28.0908 135.535 28.0908C136.692 28.0908 137.86 28.785 137.887 30.0239V30.1825C137.488 29.9551 136.611 29.608 135.562 29.608C133.425 29.608 131.259 30.7811 131.259 32.9806C131.259 34.9945 133.011 36.2873 134.963 36.2873C136.462 36.2873 137.288 35.608 137.803 34.821H137.884V35.9821H140.036V30.2364C140.036 27.5611 138.057 26.0798 135.509 26.0798ZM135.228 34.2943C134.498 34.2943 133.476 33.9352 133.476 33.0135C133.476 31.8524 134.752 31.4125 135.839 31.4125C136.823 31.4125 137.288 31.6249 137.872 31.9182C137.711 33.2648 136.579 34.2823 135.228 34.2943ZM147.886 26.4L145.323 32.9057H145.242L142.587 26.4H140.185L144.169 35.4943L141.898 40.5486H144.223L150.353 26.4H147.886ZM127.793 36H130.025V21.0015H127.793V36Z",
    fill: "#2B2733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4693 9.04038C12.1236 9.41445 11.924 9.98602 11.924 10.7341V37.2688C11.924 38.0169 12.1236 38.5885 12.4813 38.9476L12.5736 39.0284L27.3795 24.1616V23.8294L12.5617 8.95959L12.4693 9.04038Z",
    fill: "url(\"#paint0_linear\")"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3058 29.1322L27.3675 24.1736V23.8264L32.3058 18.8678L32.4131 18.9337L38.2543 22.2673C39.9263 23.213 39.9263 24.7751 38.2543 25.7327L32.4131 29.0663L32.3058 29.1322Z",
    fill: "url(\"#paint1_linear\")"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4131 29.0663L27.3676 24L12.4693 38.9596C13.0147 39.5461 13.9296 39.612 14.9519 39.0404L32.4131 29.0663Z",
    fill: "url(\"#paint2_linear\")"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4131 18.9337L14.9519 8.97457C13.9296 8.38803 13.0117 8.46883 12.4693 9.05537L27.3676 24L32.4131 18.9337Z",
    fill: "url(\"#paint3_linear\")"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3059 28.9586L14.9638 38.8519C13.9952 39.4115 13.1309 39.3726 12.5736 38.8639L12.4812 38.9566L12.5736 39.0374C13.1309 39.5432 13.9952 39.5851 14.9638 39.0255L32.4251 29.0663L32.3059 28.9586Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2544 25.5591L32.2909 28.9586L32.3982 29.0663L38.2395 25.7327C39.0769 25.2539 39.4882 24.6254 39.4882 24C39.4375 24.5746 39.0113 25.1192 38.2544 25.5591Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9519 9.14815L38.2544 22.4409C39.0114 22.8689 39.4376 23.4285 39.5031 24C39.5031 23.3746 39.0918 22.7462 38.2544 22.2674L14.9519 8.97459C13.28 8.01399 11.924 8.81599 11.924 10.7342V10.9078C11.924 8.98656 13.28 8.19953 14.9519 9.14815Z",
    fill: "#FFFFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 26.0514,
    y1: 10.4479,
    x2: 2.32214,
    y2: 16.7446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 40.4347,
    y1: 24,
    x2: 11.5175,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 29.6695,
    y1: 26.7568,
    x2: 10.5142,
    y2: 58.8646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 8.71779,
    y1: 0.214556,
    x2: 17.2638,
    y2: 14.5544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 26.0514,
    y1: 10.4479,
    x2: 2.32214,
    y2: 16.7446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 40.4347,
    y1: 24,
    x2: 11.5175,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 29.6695,
    y1: 26.7568,
    x2: 10.5142,
    y2: 58.8646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 8.71779,
    y1: 0.214556,
    x2: 17.2638,
    y2: 14.5544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore01);
export default __webpack_public_path__ + "static/media/playstore01.c0404a0fe62d75d2bad729ceb5e815d7.svg";
export { ForwardRef as ReactComponent };